module.exports = __webpack_public_path__ + "img/files-alt.2beffcfa.svg";